// this must be an object, for test purposes it's a function
var USE_MARKETPLACE = context => {
  var locale = context.locale.iso;
  var cookies = context.$cookies;
  if (cookies.get('TOGGLE_USE_MARKETPLACE_ALL')) {
    var _result = {
      'fr-FR': true,
      'nl-BE': true,
      'fr-BE': true,
      'de-DE': true,
      'es-ES': true,
      'it-IT': true,
      'fr-LU': true,
      'nl-NL': true,
      'de-AT': true,
      'pt-PT': true,
      'de-CH': true,
      'it-CH': true,
      'fr-CH': true,
      'en-GB': true
    };
    return _result[locale];
  }
  var allCookies = cookies.getAll();
  var result = {
    'fr-FR': !allCookies.withoutmarketplaceproducts,
    'nl-BE': !!allCookies.TOGGLE_USE_MARKETPLACE_BE,
    'fr-BE': !!allCookies.TOGGLE_USE_MARKETPLACE_BE,
    'de-DE': !allCookies.withoutmarketplaceproducts,
    'es-ES': !allCookies.withoutmarketplaceproducts,
    'it-IT': !allCookies.withoutmarketplaceproducts,
    'fr-LU': !!allCookies.TOGGLE_USE_MARKETPLACE_LU,
    'nl-NL': !!allCookies.TOGGLE_USE_MARKETPLACE_NL,
    'de-AT': !!allCookies.TOGGLE_USE_MARKETPLACE_DE,
    'pt-PT': !!allCookies.TOGGLE_USE_MARKETPLACE_PT,
    'de-CH': !!allCookies.TOGGLE_USE_MARKETPLACE_CH,
    'it-CH': !!allCookies.TOGGLE_USE_MARKETPLACE_CH,
    'fr-CH': !!allCookies.TOGGLE_USE_MARKETPLACE_CH,
    'en-GB': !!allCookies.TOGGLE_USE_MARKETPLACE_GB
  };
  return result[locale];
};
export var mvpMartketplace = false;
export default USE_MARKETPLACE;